import React from 'react';
import { jc, jcm } from 'utils';
import { ImagePlaceholder, ImageFallback } from 'common/components';
import { PictureCaverProps } from '../types';
import { Styles } from './picture-cover.styles';
import { RemoveButton } from './remove-button';
import { RetryButton } from './retry-button';

export const PictureCover: React.FC<PictureCaverProps> = ({
  src,
  processingIsFailed = false,
  isInProcessing = false,
  className = '',
  onRetryClick,
  onRemoveClick,
  ...htmlProps
}) => {
  const onRetryCb = React.useCallback(() => {
    onRetryClick?.(src);
  }, [onRetryClick, src]);

  const onRemoveCb = React.useCallback(() => {
    onRemoveClick?.(src);
  }, [onRemoveClick, src]);

  return (
    <div className={jc(Styles.picCover, className)} key={src} {...htmlProps}>
      <div
        className={jcm({
          [Styles.picCoverCntr]: true,
          [Styles.picCoverCntrWithErrorOutline]: processingIsFailed,
        })}
      >
        <ImagePlaceholder
          className={jcm({
            [Styles.picCoverImg]: true,
            [Styles.picCoverImgVeiled]: processingIsFailed || isInProcessing,
          })}
          src={src}
          loading="lazy"
          alt=""
          fallback={<ImageFallback width={96} height={96} />}
        />
      </div>

      {processingIsFailed && <RetryButton onClick={onRetryCb} />}

      <RemoveButton showInProcessSpinner={isInProcessing} onClick={onRemoveCb} />
    </div>
  );
};
